import classNames from 'classnames';
import React from 'react';
const Button = (props) => {
    const handleClick = (e) => {
        if (props.usesDefault != undefined && !props.usesDefault && props.onClick) {
            e.preventDefault();
        }
        props.onClick && props.onClick.call(this, e);
    };
    const handleKeyDown = (e) => {
        if (props.usesDefault != undefined && !props.usesDefault && props.onKeyDown) {
            e.preventDefault();
        }
        props.onKeyDown && props.onKeyDown.call(this, e);
    };
    return (React.createElement("button", Object.assign({ ref: props.reference, onClick: handleClick, onKeyDown: handleKeyDown, disabled: props.disabled, className: classNames('button', props.cls, props.className, { loading: props.isLoading }), type: props.type, "aria-label": props.ariaLabel, "aria-current": props.ariaCurrent, "aria-expanded": props.ariaExpanded, "aria-haspopup": props.ariaHaspopup, "aria-controls": props.ariaControls, "aria-busy": props.ariaBusy, "aria-describedby": props.ariaDescribedby }, (props.tabIndex ? { tabIndex: props.tabIndex } : {})), props.isLoading ? (React.createElement(React.Fragment, null,
        React.createElement("div", null))) : (React.createElement("span", null, props.children))));
};
Button.defaultProps = {
    cls: ['button--primary'],
    className: '',
};
export default Button;
